<template lang="pug" src="./form-dental-health-month.pug"></template>

<script>
import axios from 'axios'
import api from 'api'

export default {
  data: () => {
    return {
      firstname: '',
      lastname: '',
      childsname: '',
      mailingaddress: '',
      city: '',
      state: '',
      zip: '',
      age: '',
      schoolname: '',
      grade: '',
      parentemail: '',
      yes_no: '',
      ortho_eval_yes_no: '',
      freekit_yes_no: '',
      formSubmitted: false,
      formallSubmitted: true,
      postUrl: api + '/rg-mail/v1/schooloralhealth'
    }
  },
  methods: {
    validateBeforeSubmit () {
      this.$validator.validateAll()
      .then(result => {
        if (result) {
          this.formSubmitted = true
          this.formallSubmitted = false
          this.onSubmit()
        } else {
          console.log(result)
        }
      })
      .catch((e) => {
        console.log(e)
      })
    },
    onSubmit () {
      axios.post(this.postUrl, {
        firstname: this.firstname + ' ',
        lastname: this.lastname,
        childsname: this.childsname,
        mailingaddress: this.mailingaddress,
        city: this.city,
        state: this.state,
        zip: this.zip,
        age: this.age,
        schoolname: this.schoolname,
        grade: this.grade,
        parentemail: this.parentemail,
        yes_no: this.yes_no,
        ortho_eval_yes_no: this.ortho_eval_yes_no
        // freekit_yes_no: this.freekit_yes_no
      })
      .then(res => {
        this.firstname = ''
        this.lastname = ''
        this.childsname = ''
        this.mailingaddress = ''
        this.city = ''
        this.state = ''
        this.zip = ''
        this.age = ''
        this.schoolname = ''
        this.grade = ''
        this.parentemail = ''
        this.yes_no = ''
        this.ortho_eval_yes_no = ''
        this.freekit_yes_no = ''
      })
      .catch(e => { console.log(e) })
    }
  }
}
</script>



// WEBPACK FOOTER //
// form-dental-health-month.vue?72a3b0eb